//Converts a number to dollars
//Example: "-12.3456" returns "— $12.35"

export default function toUSD(value, decimalPlaces, toMillions) {
	const fractionDigits = !isNaN(decimalPlaces) ? decimalPlaces : 2;
	let append = "";

	if (toMillions) {
		if (value >= 1000000000) {
			value = value / 1000000000;
			append = " B";
		} else {
			value = value / 1000000;
			append = " M";
		}
	}

	let usdFormatter = new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits
	});

	return value && !isNaN(value) && usdFormatter.format(value)
		? usdFormatter.format(value) + append
		: "";
}
